import { FC, useState } from 'react';
import { ScrollMenu } from 'react-horizontal-scrolling-menu';
import 'react-horizontal-scrolling-menu/dist/styles.css';
import '/public/css/components/scrollmenu.css';
import '/public/css/components/videoCarousel.css';
import { LeftArrow } from 'components/Slider/arrows';
import { RightArrow } from 'components/Slider/arrows';
import { YoutubePlaylistVideo } from 'utils/getYoutubePlaylistVideos';
import VideoCarouselItem from './VideoCarouselItem';

interface VideoCarouselProps {
  title?: string;
  videos: YoutubePlaylistVideo[];
}

const VideoCarousel: FC<VideoCarouselProps> = ({ title, videos }) => {
  const [playingVideoId, setPlayingVideoId] = useState<string | null>(null);

  if (!videos?.length) {
    console.error('VideoCarousel: no videos to display, not rendering');
    return null;
  }

  return (
    <div className="video-carousel">
      {title && <h2 className="election-hub-2026-hdg-block">{title}</h2>}
      <div className="video-carousel-scroll-wrapper">
        <ScrollMenu LeftArrow={LeftArrow} RightArrow={RightArrow}>
          {videos.map((video) => (
            <VideoCarouselItem
              key={video.id}
              itemId={video.id}
              video={video}
              isPlaying={playingVideoId === video.id}
              onPlay={() => setPlayingVideoId(video.id)}
            />
          ))}
        </ScrollMenu>
      </div>
    </div>
  );
};

export default VideoCarousel;
